'use client'

import { useCallback } from 'react'
import { useMap } from '@vis.gl/react-google-maps'
import { Minus, Plus } from 'lucide-react'

import { Button } from '@/ui'

/**
 * 地图控件
 */
const MapControls = ({ id }: { id: string }) => {
  const map = useMap(id)

  const handleZoomIn = useCallback(() => {
    if (map) {
      const currentZoom = map.getZoom() || 12
      map.setZoom(currentZoom + 1)
    }
  }, [map])

  const handleZoomOut = useCallback(() => {
    if (map) {
      const currentZoom = map.getZoom() || 12
      map.setZoom(currentZoom - 1)
    }
  }, [map])

  const handleCurrentLocation = useCallback(() => {
    if (map && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          map.setCenter({ lat: latitude, lng: longitude })
          map.setZoom(12)
        },
        () => {},
        {
          // 可选配置项
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        },
      )
    }
  }, [map])

  return (
    <div className="absolute bottom-4 right-4 z-10 flex flex-col gap-4">
      <div className="flex flex-col">
        <Button
          variant="secondary"
          className="h-[40px] w-[40px] rounded-b-none rounded-t-md bg-white p-0"
          onClick={handleZoomIn}>
          <Plus className="h-4 w-4" />
        </Button>
        <div className="bg-white px-[2px]">
          <div className="h-[1px] bg-[#EBEBEB]"></div>
        </div>
        <Button
          variant="secondary"
          className="h-[40px] w-[40px] rounded-b-md rounded-t-none bg-white p-0"
          onClick={handleZoomOut}>
          <Minus className="h-4 w-4" />
        </Button>
      </div>
      <Button
        variant="secondary"
        className="h-[40px] w-[40px] rounded-md bg-white p-0"
        onClick={handleCurrentLocation}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M13 18V17H11V18H13ZM11 18V21H13V18H11Z" fill="black" />
          <path d="M18 11H17V13H18V11ZM18 13H21V11H18V13Z" fill="black" />
          <path d="M6 13H7V11H6V13ZM3 13H6V11H3V13Z" fill="black" />
          <path d="M11 6V7H13V6H11ZM13 6V3H11V6H13Z" fill="black" />
        </svg>
      </Button>
    </div>
  )
}

export default MapControls
